import actions from './smsActions'
import mutations from './smsMutations'
import state from './smsState'
import getters from './smsGetters'

export default {
  namespaced: true,
  getters,
  actions,
  state,
  mutations,
}
